import {
    Box,
    Button,
    Grid,
    Loader,
    LoadingOverlay, Paper,
    useMantineTheme
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import { default as React, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InputField, { InputFieldTypes } from "../components/input_field";
import { useAuth } from '../contexts/auth.context';
import { useLanguage } from '../contexts/language.context';
import { GET_REDIRECT_DATA } from '../services/auth';

export default function RedirectPage() {
    const [loading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({});
    const navigate = useNavigate();
    const { search, pathname } = useLocation();
    const { signIn, onChangeRole } = useAuth();
    const { str } = useLanguage();
    const theme = useMantineTheme();
    const isMobile = useMediaQuery('(max-width: 900px)');
    const handlechange = (dt: any) => setFormData((fd: any) => ({ ...fd, ...dt }))

    const requestForm = pathname === "/appsumo/redirect/license";
    const validData = useMemo(() => {
        return formData?.name &&
            formData?.email &&
            formData?.brand &&
            formData?.password
    }, [formData]);

    useEffect(() => {
        if (!requestForm) {
            submit();
        }
    }, [search.toString(), pathname.toString(), requestForm]);

    const submit = () => {
        setLoading(true);
        let queryObject: any = {};
        const params = new URLSearchParams(search);
        for (let [key, value] of params.entries()) {
            queryObject[key] = value;
        }
        GET_REDIRECT_DATA({
            query: queryObject,
            pathname,
            data: formData,
        })
            .then(({ signinUser, redirectType, activeRole }) => {
                if (signinUser) signIn(signinUser, () => {
                    if (activeRole) onChangeRole(activeRole, true);
                    if (redirectType) {
                        if (redirectType === "whitelabel_onboarding") navigate("/onboarding");
                        if (redirectType === "first_agent") navigate("/thank-you");
                    } else {
                        navigate("/");
                    }
                });
            })
            .catch(err => {
                if (!requestForm) navigate("/not-found")
                showNotification({ message: err.message, color: "red" });
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return !requestForm
        ? loading
            ? <Loader color={theme.colors.gray[2]} />
            : null
        : <div style={{
            backgroundColor: theme.colors.dark[8],
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundAttachment: 'fixed',
            position: 'relative',
            minHeight: '100vh',
            zIndex: 0,
            ...(
                isMobile
                    ? {
                        padding: 20,
                    }
                    : {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        padding: '10vh 20vw',
                    }
            )
        }}>
            <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, background: '#00000055', zIndex: -1 }}>
            </div>
            <Paper p="md">
                <Grid>
                    <Grid.Col span={{ base: 12, md: 12 }}>
                        {/* {configs?.image && <div style={{ display: 'flex', margin: '40px 0 10px', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <img alt={configs.name} src={configs?.image} style={{ maxHeight: 80, maxWidth: '180px' }} />
                        </div>} */}

                        {/* <Title ta="center" mt="xl" order={2}>{steps[selectedTab]?.title}</Title>
                        <Text ta="center" size="sm">{steps[selectedTab]?.subtitle}</Text> */}

                        <Box style={{ padding: isMobile ? '20px 10px 20px 10px' : '40px 60px 40px 60px' }}>

                            <form onSubmit={e => { e.preventDefault(); submit() }} style={{ overflowY: 'auto' }}>
                                <Paper p="md">
                                    <InputField
                                        title={str("YOUR_NAME")}
                                        mb="lg"
                                        autoComplete="off"
                                        name="name"
                                        value={formData?.name}
                                        onChange={handlechange}
                                    />
                                    <InputField
                                        title={str("EMAIL")}
                                        mb="lg"
                                        name="email"
                                        autoCapitalize="off"
                                        value={formData?.email}
                                        onChange={handlechange}
                                    />
                                    <InputField
                                        title={str("PASSWORD")}
                                        mb="lg"
                                        name="password"
                                        fieldType={InputFieldTypes.PASSWORD}
                                        value={formData?.password}
                                        onChange={handlechange}
                                    />

                                    <InputField
                                        title={str("SIGNUP.BRAND_NAME")}
                                        mb="lg"
                                        name="brand"
                                        value={formData?.brand}
                                        onChange={handlechange}
                                    />
                                </Paper>
                                <Box mt="xl" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Button
                                        type="submit"
                                        loading={loading}
                                        disabled={!validData}
                                        variant="filled"
                                        size="md">{str("CONTINUE")}</Button>
                                </Box>
                            </form>
                        </Box>
                    </Grid.Col>
                </Grid>
            </Paper>
        </div>
}